import { Button } from "react-bootstrap";
import image from "../img/image-password.png";
import { useNavigate } from "react-router";
import AuthContext from "../context/AuthContext";
import { useContext } from "react";

function SucceededChangePassword() {
    const navigate = useNavigate();
    const { logout } = useContext(AuthContext);

    const handleClick = () => {
        logout();
        navigate("/login");
    }

    return (
        <>
            <section className="container-fluid" style={{ background: "#D6E4FF", minHeight: "100vh" }}>
                <div>
                    <div className="kl-succes-image">
                        <img src={image} alt="reset password" />
                    </div>
                    <div className="kl-message-reset-password">
                        <h1>
                            Mot de passe crée avec succès !
                        </h1>
                        <div>
                            Tous les autres appareils seront déconnectés
                        </div>
                    </div>
                    <div className="kl-button-start-contab">
                        <Button
                            type="submit"
                            variant={"primary"}
                            size="lg"
                            onClick={handleClick}
                        >
                            Compris
                        </Button>
                    </div>
                </div>
            </section>
        </>
    );
}

export default SucceededChangePassword;